// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IZ4e","left":"styles_left__31-5r"};